var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.clase,style:({width: _vm.width, height:_vm.heigth, position: _vm.position, top:_vm.top, left:_vm.left }),on:{"click":_vm.clicked}},[(_vm.showTitle)?_c('p',[_vm._v(_vm._s(_vm.titulo))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }